import api from '../services/api';
import { getSiteId } from '../siteId/siteId';

const USER_ADDRESSES_V2_URL = '/userAddresses/v2';
const CREATE_ADDRESS_URL = '/users/addresses';

const userAddressService = {
    getShippingAddresses,
    getBillingAddresses,
    createAddress,
    updateAddress,
    deleteAddress,
};

export default userAddressService;

function getShippingAddresses () {
    const requestConfig = {
        url: `${USER_ADDRESSES_V2_URL}/shipping`,
        method: 'GET',
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}

function getBillingAddresses () {
    const requestConfig = {
        url: `${USER_ADDRESSES_V2_URL}/billing`,
        method: 'GET',
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}

// Note the inconsistent path: creating goes to /users/addresses, with no /v2, while the rest of the
// address book lives under /userAddresses/v2.
function createAddress (addressPayload) {
    const requestConfig = {
        url: CREATE_ADDRESS_URL,
        method: 'POST',
        data: addressPayload,
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}

function updateAddress (addressId, addressPayload) {
    const requestConfig = {
        url: `${USER_ADDRESSES_V2_URL}/${addressId}`,
        method: 'PUT',
        data: addressPayload,
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}

function deleteAddress (addressId) {
    const requestConfig = {
        url: `${USER_ADDRESSES_V2_URL}/${addressId}`,
        method: 'DELETE',
        params: {
            siteId: getSiteId(),
        },
    };

    return api(requestConfig);
}
